var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00cc99",
    d: "M2 41.554V34h13.105v-1.672a5.217 5.217 0 0 1-2.283-5.212c.33-2.086 1.959-3.82 4.025-4.259 3.396-.722 6.4 1.842 6.4 5.113a5.21 5.21 0 0 1-2.352 4.358V34H34v13.105h-1.672a5.21 5.21 0 0 0-4.358-2.35c-3.271 0-5.835 3.002-5.113 6.398.44 2.066 2.173 3.696 4.259 4.026a5.217 5.217 0 0 0 5.212-2.284H34V66H9.154A7.154 7.154 0 0 1 2 58.846z",
    opacity: 1,
    "data-original": "#00cc99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd542",
    d: "M52.895 34v1.672a5.217 5.217 0 0 1 2.283 5.213c-.33 2.086-1.959 3.819-4.025 4.258-3.396.722-6.4-1.842-6.4-5.113a5.21 5.21 0 0 1 2.352-4.358V34H34V20.895h1.672a5.217 5.217 0 0 0 5.213 2.284c2.086-.33 3.82-1.96 4.258-4.026.722-3.396-1.842-6.399-5.113-6.399a5.21 5.21 0 0 0-4.358 2.351H34V2h24.846A7.154 7.154 0 0 1 66 9.154V34z",
    opacity: 1,
    "data-original": "#ffd542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2c538",
    d: "M66 9.15V34h-3.93V12.6c0-3.95-3.2-7.16-7.15-7.16H34V2h24.85C62.8 2 66 5.2 66 9.15z",
    opacity: 1,
    "data-original": "#f2c538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f34c6e",
    d: "M66 34v24.846A7.154 7.154 0 0 1 58.846 66H34V52.895h-1.672a5.217 5.217 0 0 1-5.212 2.284c-2.086-.33-3.82-1.96-4.259-4.026-.722-3.396 1.842-6.399 5.113-6.399a5.21 5.21 0 0 1 4.358 2.351H34V34h13.105v1.672a5.217 5.217 0 0 0-2.283 5.214c.33 2.086 1.96 3.819 4.026 4.258 3.396.721 6.398-1.843 6.398-5.114a5.21 5.21 0 0 0-2.351-4.358V34z",
    opacity: 1,
    "data-original": "#f34c6e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e24067",
    d: "M66 34v24.85C66 62.8 62.8 66 58.85 66H34v-3.4h20.96c3.96 0 7.16-3.2 7.16-7.15V34z",
    opacity: 1,
    "data-original": "#e24067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02c18b",
    d: "M2 34v24.85C2 62.8 5.2 66 9.15 66H34v-3.4H13.04a7.15 7.15 0 0 1-7.16-7.15V34z",
    opacity: 1,
    "data-original": "#02c18b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2dcef6",
    d: "M45.143 19.153c-.439 2.066-2.172 3.695-4.258 4.026a5.217 5.217 0 0 1-5.213-2.284H34V34H20.895v-1.672a5.217 5.217 0 0 0 2.284-5.213c-.331-2.086-1.96-3.82-4.027-4.258-3.396-.722-6.398 1.842-6.398 5.113a5.21 5.21 0 0 0 2.351 4.358V34H2V9.154A7.154 7.154 0 0 1 9.154 2H34v13.105h1.672a5.21 5.21 0 0 1 4.358-2.351c3.271 0 5.835 3.003 5.113 6.399z",
    opacity: 1,
    "data-original": "#2dcef6",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000033",
    d: "M66 13.322a1 1 0 0 0 1-1V9.154C67 4.658 63.343 1 58.847 1H21.355a1 1 0 1 0 0 2H33v12.105a1 1 0 0 0 1 1h1.672c.336 0 .65-.168.835-.449a4.21 4.21 0 0 1 3.523-1.902c2.666 0 4.72 2.45 4.135 5.191-.35 1.647-1.764 2.98-3.436 3.246-1.674.263-3.295-.44-4.222-1.846a1.002 1.002 0 0 0-.835-.45H34a1 1 0 0 0-1 1V33H21.895v-.162a6.258 6.258 0 0 0 2.351-4.868 6.242 6.242 0 0 0-6.252-6.231c-3.203.008-6.024 2.444-6.22 5.874-.121 2.139.795 4.006 2.332 5.225V33H3V9.154A6.161 6.161 0 0 1 9.154 3h6.622a1 1 0 1 0 0-2H9.154C4.658 1 1 4.658 1 9.154v33.19a1 1 0 1 0 2 0V35h12.106a1 1 0 0 0 1-1v-1.672c0-.33-.165-.648-.45-.835a4.237 4.237 0 0 1-1.9-3.55 4.233 4.233 0 0 1 4.247-4.204 4.241 4.241 0 0 1 4.24 4.206 4.234 4.234 0 0 1-1.9 3.548 1 1 0 0 0-.448.835V34a1 1 0 0 0 1 1H33v11.105h-.163a6.202 6.202 0 0 0-4.867-2.351 6.21 6.21 0 0 0-4.845 2.313c-1.193 1.475-1.647 3.405-1.246 5.294.527 2.477 2.568 4.407 5.08 4.805 2.27.364 4.481-.502 5.879-2.27H33V65H9.154A6.16 6.16 0 0 1 3 58.847V46.569a1 1 0 1 0-2 0v12.278C1 63.343 4.658 67 9.154 67h32.409a1 1 0 1 0 0-2H35V52.896a1 1 0 0 0-1-1h-1.672c-.336 0-.65.168-.835.449-.925 1.404-2.544 2.107-4.222 1.846-1.672-.264-3.085-1.6-3.435-3.246-.586-2.75 1.475-5.191 4.134-5.191 1.42 0 2.738.71 3.523 1.902.186.28.5.45.835.45H34a1 1 0 0 0 1-1V35h11.106v.163a6.186 6.186 0 0 0-2.332 5.232 6.207 6.207 0 0 0 6.157 5.863c3.556.042 6.267-2.81 6.31-6.146 0-.027.005-.054.005-.082a6.257 6.257 0 0 0-2.351-4.867V35H65v23.847A6.16 6.16 0 0 1 58.847 65h-12a1 1 0 1 0 0 2h12C63.343 67 67 63.343 67 58.847V17.23a1 1 0 1 0-2 0V33H52.895a1 1 0 0 0-1 1v1.673a1 1 0 0 0 .449.835 4.23 4.23 0 0 1 1.9 3.547c-.013 2.342-1.936 4.215-4.25 4.206-2.347.003-4.222-1.912-4.237-4.204a4.241 4.241 0 0 1 1.9-3.55 1 1 0 0 0 .449-.834V34a1 1 0 0 0-1-1H35V21.895h.162c1.398 1.767 3.599 2.634 5.879 2.271 2.512-.398 4.554-2.328 5.081-4.805.849-3.994-2.16-7.607-6.092-7.607-1.909 0-3.691.87-4.867 2.351H35V3h23.847A6.16 6.16 0 0 1 65 9.154v3.168a1 1 0 0 0 1 1z",
    opacity: 1,
    "data-original": "#000033",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonData);
export default __webpack_public_path__ + "static/media/commonData.29ff38e129e94d2b78511b6157040a0f.svg";
export { ForwardRef as ReactComponent };